import * as React from 'react';
import { Card, Row, Col, Input, Button, Alert, Divider } from 'antd';
import strings from '../eyeguide-localization/strings.settings';
import service from '../service/apolloclient.service';
import Token from './common/token';
import '../css/Settings.scss';
import UpdatePassword from './settings/updatePassword';
import ForgotPassword from './settings/forgotPassword';
import { STATICKEYS, staticProperties } from './common/staticProperties';
import LocalStorage from '../service/localstorage';

const storage = new LocalStorage();

interface ISettingsProps {
    refreshHeaderLayout: any;
}

/**
 * State definition
 */
interface ISettingsState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorusername: boolean;
    errorfirstname: boolean;
    errorlastname: boolean;
    erroremail: boolean;
    errorphone: boolean;
    username:       string;
    firstname:      string;
    lastname:       string;
    email:          any ;
    phone: string;
    user: any;
    loggedInUid: string;
    unAuth:         boolean;
    isModalVisible:     boolean;
    isSuccess: boolean;
    isFPModalVisible: boolean;
    userEmail:  string;
}

export default class Settings extends React.Component<ISettingsProps, ISettingsState> {
    
    constructor(props: ISettingsProps) {
        super(props); 
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorusername: false,
            errorfirstname: false,
            errorlastname: false,
            erroremail: false,
            errorphone: false,
            username : '',
            firstname : '',
            lastname : '',
            email : '',
            phone: '',
            user: [],
            loggedInUid: Token.decodeToken().uid,
            unAuth          : false,
            isModalVisible: false,
            isSuccess: false,
            isFPModalVisible: false,
            userEmail: ''
        };

    }

    async componentDidMount() {
        staticProperties.set(STATICKEYS.selectedKey, 'settings');
        staticProperties.set(STATICKEYS.selectedRoster, '');
        // let uid: string = Token.decodeToken().uid;
        let ser = new service();
        let userData = await ser.getUser('');
        this.setState({
            username : userData.username,
            firstname : userData.firstname,
            lastname : userData.lastname,
            email : userData.email,
            userEmail: userData.email,
            phone: userData.phone,
            user: userData
        });
 
    }

    render() {
        return(
            <Card 
                title={strings.lsSettingsTxt}
                className="Settings" 
                bordered={false} 
                style={{ margin: '24px 16px' }} 
            >
           { this.state.isSuccess ?
            <Alert 
                banner={true} 
                closable={true} 
                message={strings.lsSuccessTxt}
                description={strings.lsSettingsSuccess}
                type="success" 
                showIcon={true} 
                onClose={() => this.setState({isSuccess: false})}
            /> : '' }
            <Row className="row">
                <Col xs={1} sm={1} md={6} lg={6} xl={5} />
                <Col xs={8} sm={8} md={4} lg={4} xl={3} className="labelFrame">
                    <div className="label">
                        <span>   {strings.lsFNameTxt}      
                        <span className="labelReq"> * </span>
                        :</span>
                    </div>
                </Col>
                <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                    <Input 
                        value={this.state.firstname}
                        onChange={(val) => this.setState({firstname: val.target.value})}
                        className={this.state.errorfirstname ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder="e.g. Johnny"
                        autoFocus={true}
                    />
                </Col>
                <Col xs={1} sm={1} md={4} lg={4} xl={4}/>
            </Row>
            <Row className="row">
                <Col xs={1} sm={1} md={6} lg={6} xl={5} />
                <Col xs={8} sm={8} md={4} lg={4} xl={3} className="labelFrame">
                <div className="label">
                    <span> {strings.lsLNameTxt}
                        <span className="labelReq"> * </span>
                    :</span>
                </div>
                </Col>
                <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                    <Input 
                        value={this.state.lastname} 
                        onChange={(val) => this.setState({lastname: val.target.value})}
                        className={this.state.errorlastname ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder="eg Thomas" 
                    />
                </Col>
                <Col xs={1} sm={1} md={4} lg={4} xl={4}/>
            </Row>
            <Row className="row">
                <Col xs={1} sm={1} md={6} lg={6} xl={5} />
                <Col xs={8} sm={8} md={4} lg={4} xl={3} className="labelFrame">
                <div className="label">
                        <span> {strings.lsEmailTxt}
                            <span className="labelReq"> * </span>
                        :</span>
                </div>
                </Col>
                <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                    <Input
                        value={this.state.email} 
                        onChange={(val) => this.setState({email: val.target.value})}
                        className={this.state.erroremail ? 
                            this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder="eg johny.thomas@school.edu" 
                    />
                </Col>
                <Col xs={1} sm={1} md={4} lg={4} xl={4}/>
            </Row>
            <Row className="row">
                <Col xs={1} sm={1} md={6} lg={6} xl={5} />
                <Col xs={8} sm={8} md={4} lg={4} xl={3} className="labelFrame">
                    <div className="label">
                        <span> {strings.lsUsrNameTxt}
                            <span className="labelReq"> * </span>
                        :</span>
                    </div>
                </Col>
                <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                    <Input 
                        value={this.state.username}
                        onChange={(val) => this.setState({username: val.target.value})}
                        className={this.state.errorusername ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder="e.g. jjohnson" 
                        disabled={this.state.user instanceof Array && 
                            this.state.user.length === 0 ? false : true}

                    />
                </Col>
                <Col xs={1} sm={1} md={4} lg={4} xl={4} />                   
            </Row>
            <Row className="row">
                <Col xs={1} sm={1} md={6} lg={6} xl={5} />
                <Col xs={8} sm={8} md={4} lg={4} xl={3} className="labelFrame">
                <div className="label">
                        <span> {strings.lsMobilePhTxt}
                            <span className="labelReq"> * </span>
                        :</span>
                </div>
                </Col>
                <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                    <Input
                        value={this.state.phone} 
                        onChange={(val) => this.setState({phone: val.target.value})}
                        className={this.state.errorphone ? 
                            this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder="eg 0123-456-789" 
                    />
                </Col>
                <Col xs={1} sm={1} md={4} lg={4} xl={4}/>
            </Row>

            <Row>
                <Col md={10} lg={12} xl={12} style={{padding: '10px'}}>
                    <div className="buttonRight"> 
                        <Button 
                            onClick={e => {
                                this.showUpdatePasswordModal();
                            }}      
                            className="updatePwdBtn"     
                        > 
                            {strings.lsUpdatePwdTxt}
                        </Button> 
                    </div>
                </Col>
                <Col md={14} lg={12} xl={12} style={{padding: '10px', marginTop: '5px'}}>
                    <div className="buttonLeft"> 
                    <a onClick={e => this.showForgotPasswordModal()}>
                        {strings.lsForgotPasswordTxt}
                    </a>
                        {/* <Button 
                                onClick={e => this.updateSettings()} 
                                type="primary" 
                                style={{width: '100%'}}
                        > 
                        {strings.lsUpdateSettingsTxt} 
                        </Button>  */}
                    </div>
                </Col>
            </Row>
            <Divider/>
            <div className="updateSetBt">
            <Button 
                onClick={e => this.updateSettings()} 
                type="primary" 
            > 
                {strings.lsUpdateSettingsTxt} 
            </Button> 
            </div>
            <UpdatePassword
                isModalVisible={this.state.isModalVisible}
                modalClosed={() => this.setState({isModalVisible: false})}
            />
            <ForgotPassword
                isModalVisible={this.state.isFPModalVisible}
                modalClosed={() => this.setState({isFPModalVisible: false})}
                userEmail={this.state.userEmail}
            />
            </Card>
        );
    }

    private showUpdatePasswordModal() {
        this.setState({
            isModalVisible: true
        });
    }

    private showForgotPasswordModal() {
        this.setState({
            isFPModalVisible: true
        });
    }

    private async updateSettings() {
        if (this.validateInput()) {
            console.log('');
            let ser = new service();
            let resp = await ser.updateAccount(this.getUserInput()) ;
            console.log('updateAccount resp', resp);
            if (resp.status === 0) {
                storage.setFirstName(this.state.firstname);
                storage.setLastName(this.state.lastname);
                this.setState({
                    isSuccess: true,
                    userEmail: this.state.email
                });
                this.props.refreshHeaderLayout();
            }
        }
    }

    private getUserInput() {
        console.log('user', this.state.user);
        let input = {
            firstname : this.state.firstname,
            lastname : this.state.lastname,
            email    : this.state.email,
            phone   : this.state.phone,
            organizations  : this.state.user.roleid < 6 ? undefined : []
        };
        console.log('userInput', input);
        return input;
    }

    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorfirstname: boolean = false;
        let errorlastname: boolean = false;
        let erroremail: boolean = false;
        let errorphone: boolean = false;
        this.state.firstname !== null && (this.state.firstname === undefined || this.state.firstname.trim() === '') ?
                    errorfirstname = true : errorfirstname = false;
        this.state.lastname !== null && (this.state.lastname === undefined || this.state.lastname.trim() === '') ?
                    errorlastname = true : errorlastname = false;
        this.state.email !== null && (this.state.email === undefined || 
                    this.state.email.trim() === '') ? erroremail = true 
                    : erroremail = false;
        this.state.phone !== null && (this.state.phone === undefined || 
                    this.state.phone.trim() === '') ? errorphone = true 
                    : errorphone = false;
        if (errorfirstname || errorlastname || erroremail || errorphone) { 
            isValid = false; 
        }
        this.setState({errorfirstname, errorlastname, erroremail, errorphone});
        return isValid;
    }

}


// WEBPACK FOOTER //
// ./src/components/Settings.tsx